module.exports = __webpack_public_path__ + "img/interactive-kiosks-portrait-landscape old.5910745a.webp";